import { useCallback, useContext } from 'react';
import { get, isEmpty } from 'lodash';

import {
    HOTJAR_TAGS,
    TRACKING_EVENTS,
} from '../../../../constants/TrackingConstants';
import PositionContext from '../../../../contexts/PositionContext';
import TrackingContext from '../../../../contexts/TrackingContext';

export const useCampaignTracking = ({
    isJobCampaignPage,
    campaignDetails,
    originalCampaignDetails,
}) => {
    const { position } = useContext(PositionContext);
    const { trackEvent, trackTag } = useContext(TrackingContext);

    const trackChanges = useCallback((cb, eventName, params) => {
        cb(eventName, {
            ...(!isEmpty(position) && {
                positionName: position.jobTitle,
                positionId: position._id,
            }),
            employerId: position.employerId,
            ...params,
        });
    }, [position]);

    const trackCampaignChangesInNeeded = useCallback((updatedCampaignData) => {
        if (!isJobCampaignPage) return;

        const isCampaignUpdated = (campaignDetails.name !== originalCampaignDetails.name)
            || (campaignDetails.senderUser && !originalCampaignDetails.senderUser)
            || (campaignDetails.senderUser?.userEmail !== originalCampaignDetails.senderUser?.userEmail);

        if (isCampaignUpdated) {
            const trackData = {
                campaignPrevName: originalCampaignDetails.name,
                campaignName: updatedCampaignData.name,
                campaignPrevSenderEmail: get(originalCampaignDetails, 'senderUser.userEmail', ''),
                campaignPrevSenderRole: get(originalCampaignDetails, 'senderUser.role'),
                campaignSenderEmail: updatedCampaignData.senderUser?.userEmail,
                campaignSenderRole: updatedCampaignData.senderUser?.role,
                campaignSenderPool: updatedCampaignData.senderPoolName,
            };
            trackChanges(trackEvent, TRACKING_EVENTS.CAMPAIGN_DETAILS_UPDATED, trackData);
            trackChanges(trackTag, [HOTJAR_TAGS.CAMPAIGN_DETAILS_UPDATED], trackData);
        }

        trackChanges(trackEvent, TRACKING_EVENTS.CAMPAIGN_CHANGES_SAVED, {
            campaignName: updatedCampaignData.name,
        });
        trackChanges(trackTag, [HOTJAR_TAGS.CAMPAIGN_CHANGES_SAVED], {
            campaignName: updatedCampaignData.name,
        });
    }, [campaignDetails, originalCampaignDetails, isJobCampaignPage]);

    return {
        trackChanges,
        trackCampaignChangesInNeeded,
    };
};
